import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv, titleMRClass } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { defaultWMS1020_R01HeaderDto, WMS1020_R01DetailDto, WMS1020_R01HeaderDto, WMS1020_R01LotDto } from "./Dto_WMS1020_R01";
import { useWMS1020_R01Store } from "./Store_WMS1020_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { LotTable_WMS1020_R01 } from "./LotTable_WMS1020_R01";
import { CheckboxButtonForm } from "src/components/common/form/checkbox/CheckboxButtonForm";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";



interface Props {
	editable: boolean
	defaultWMS1020_R01HeaderRow: WMS1020_R01HeaderDto;
	handleDetailInfoCode: (headerData: WMS1020_R01HeaderDto) => void;
	handleFetchDetailList: (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, previousOrderNo: string | undefined) => void;
}

export const Info_WMS1020_R01 = (props: Props) => {

	const { 
		editable,
		defaultWMS1020_R01HeaderRow,
		handleDetailInfoCode, handleFetchDetailList,
	} = props;

	// 
	const { inoutClassList, wmsCdList, compCdList, } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { selectedWMS1020_R01, 
			editWMS1020_R01, setEditWMS1020_R01,
			WMS1020_R01DetailList, deletedWMS1020_R01DetailList,
			transportComplete, setTransportComplete,
			warehouseCdListToUseList,
	} = useWMS1020_R01Store();


	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';
	const addressHandleFoucsId = 'addressInput2';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd',
				taxEmail: 'email',
				post: 'post',
				address: 'address',
				detailAddress: 'otherAddress',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: editWMS1020_R01?.customCd || '',
				customNm: editWMS1020_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editWMS1020_R01?.empNo || '',
				empNm: editWMS1020_R01?.empNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editWMS1020_R01,
		setEditData: setEditWMS1020_R01,
		defaultData: defaultWMS1020_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1020_R01'
	});

	// 입고일자 달력 팝업 상태
	const [orderPickerVisible, setOrderPickerVisible] = useState(false);
	const [orderPickerPos, setOrderPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});
	const [deadlinePickerVisible, setDeadlinePickerVisible] = useState(false);
	const [deadlinePickerPos, setDeadlinePickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const prevWarehouseCdRef = useRef<string | undefined>(undefined);
	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);

	// 같은 입고지시에서 창고만 바뀌면 상세를 다시 조회한다. 헤더 전환으로 창고가 바뀐 경우는 Content가 조회한다.
	useEffect(() => {
		const warehouseCd = editWMS1020_R01?.warehouseCd;
		const wmsOrderNo = editWMS1020_R01?.wmsOrderNo;

		if (!warehouseCd || !wmsOrderNo) {
			prevWarehouseCdRef.current = warehouseCd;
			prevWmsOrderNoRef.current = wmsOrderNo;
			return;
		}

		const warehouseChanged = prevWarehouseCdRef.current !== undefined
			&& prevWarehouseCdRef.current !== warehouseCd;
		const sameOrder = prevWmsOrderNoRef.current === wmsOrderNo;

		prevWarehouseCdRef.current = warehouseCd;
		prevWmsOrderNoRef.current = wmsOrderNo;

		if (warehouseChanged && sameOrder) {
			handleFetchDetailList(wmsOrderNo, warehouseCd, true, undefined);
		}
	}, [editWMS1020_R01?.warehouseCd, editWMS1020_R01?.wmsOrderNo, handleFetchDetailList]);


	const handleDateChange = useCallback((field: keyof WMS1020_R01HeaderDto, value: any) => {
		setEditWMS1020_R01({
			...defaultWMS1020_R01HeaderRow,
			...editWMS1020_R01,
			[field]: value
		});
	}, [editWMS1020_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		let additionalUpdates = {};
		// 입고물류(logicCenter)가 변경될 때, 해당 물류의 첫 번째 창고로 warehouseCd 자동 세팅
		if (name === 'logicCenter') {
			const availableWarehouses = warehouseCdListToUseList(value);
			additionalUpdates = {
				warehouseCd: availableWarehouses[0]?.warehouseCd || ''
			};
		}

		setEditWMS1020_R01({
			...defaultWMS1020_R01HeaderRow,
			...editWMS1020_R01,
			[name]: value,
			...additionalUpdates
		});
	}, [editWMS1020_R01, defaultWMS1020_R01HeaderRow, warehouseCdListToUseList]);



	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				<InputForm title="입고지시번호" value={editWMS1020_R01?.wmsOrderNo || ""} 
					editable={false}
					name="wmsOrderNo" 
					onChange={handleChange} />
				<BRDiv />

				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editWMS1020_R01?.compCd}
					data={compCdList}
					editable={!transportComplete}
					onChange={handleChange}
				/>
				<SingleDateForm
					title="입고일자"
					value={editWMS1020_R01?.orderDt ? new Date(editWMS1020_R01.orderDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('orderDt', formatDate(value))}
					editable={true}
					visible={orderPickerVisible}				setVisible={setOrderPickerVisible}
					onChange={handleChange}
					pickerPos={orderPickerPos}						setPickerPos={setOrderPickerPos}
				/>
				<BRDiv />


				<DropDownForm
					title="입고구분"
					name="inoutClass"
					initLabelLess={false}
					value={editWMS1020_R01?.inoutClass} // 입고구분값 110으로 고정
					data={inoutClassList}
					editable={false}
					onChange={handleChange}
				/>
				<BRDiv />

				<CodeForm
					label="거래처"
					value={editWMS1020_R01?.customCd || ""}
					custNmValue={editWMS1020_R01?.customNm || ""}
					editable={false}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
				<CodeForm
					label="입고담당자"
					value={editWMS1020_R01?.empNo || ""}
					custNmValue={editWMS1020_R01?.empNm || ""}
					editable={!transportComplete}
					handleFoucsId={empInfoHandleFoucsId}
					name="empNo"
					handleChange={getFieldHandlers('empNo').onChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<BRDiv />
				
				<DropDownForm<SysCodeDto> 
						title="입고물류"
						data={wmsCdList}
						value={editWMS1020_R01?.logicCenter || ""}
						name="logicCenter" 
						editable={editWMS1020_R01?.closeTag === 'N'}
						initLabelLess={true}
						onChange={handleChange} />
				<DropDownForm
					title="창고번호"
					name="warehouseCd"
					initLabelLess={true}
					value={editWMS1020_R01?.warehouseCd}
					data={warehouseCdListToUseList(editWMS1020_R01?.logicCenter || '')}
					editable={editWMS1020_R01?.closeTag === 'N'}
					onChange={handleChange}
				/>
				<BRDiv />

				<SingleDateForm
					title="납기일자"
					value={editWMS1020_R01?.deadlineDt ? new Date(editWMS1020_R01.deadlineDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('deadlineDt', formatDate(value))}
					editable={!transportComplete}
					visible={deadlinePickerVisible}				setVisible={setDeadlinePickerVisible}
					onChange={handleChange}
					pickerPos={deadlinePickerPos}						setPickerPos={setDeadlinePickerPos}
				/>
				{/* <CheckboxButtonForm
					title="마감여부"
					value={editWMS1020_R01?.closeTag || 'N'}
					name="closeTag"
					editable={false}
					onChange={(e) => { setEditWMS1020_R01({
						...defaultWMS1020_R01HeaderRow,
						...editWMS1020_R01,
						closeTag: e.target.value === 'Y' ? 'Y' : 'N' }) 
					}}
				/> */}
				<BRDiv />
				
				<InputForm
					title="비고"
					value={editWMS1020_R01?.remark || ""}
					editable={!transportComplete}
					name="remark"
					wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "w-full min-w-full"
					}}
					onChange={handleChange}
				/>
		</div>
	)
}